/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class PendingWorkflowItem {

        public sourceWorkflowBlock: IWorkflowBlock;
        public pendingWorkflowBlock: IWorkflowBlock;

        constructor(sourceWorkflowBlock: IWorkflowBlock, pendingWorkflowBlock: IWorkflowBlock) {
            this.sourceWorkflowBlock = sourceWorkflowBlock;
            this.pendingWorkflowBlock = pendingWorkflowBlock;
        }

        public sourceIsMultipleOutputAndPendingIsNotFirstToBlock() : boolean {
            if (this.sourceWorkflowBlock.getOutputType() !== Wars.Domain.Model.Codes.Enums.BlockOutputType.Multiple) return false;
            return this.pendingWorkflowBlock.id !== this.sourceWorkflowBlock.toBlocks[0].id;
        }
    }
}